import React, { useEffect } from 'react';
import { Line, Pie, defaults } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import api from './../../services/axios'
import Loading from './../../compoments/Loading';
import Grid from '@material-ui/core/Grid';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import Button from '@material-ui/core/Button';
import DatePicker from './../../compoments/DatePicker';
import TimePickerCustom from './../../compoments/TimePickerCustom';


const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    backgroundColor: '#F2F2F2',
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}));

const options = {
  plugins: {
    legend: {
      display: true,
    }
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
};




let tmaTmeSelectedData = JSON.parse(localStorage.getItem('tmaTmeSelectedData'));
if (null === tmaTmeSelectedData) {
  tmaTmeSelectedData = [];
}

export default function Retalorios() {

  // const [tmaTmeSelectedData, setTmaTmeSelectedData] = React.useState([]);

  // https://www.chartjs.org/docs/latest/configuration/legend.html
  const defaultLegendClickHandler = defaults.plugins.legend.onClick;

  const tmaTmeLegendClickHandler = function (e, legendItem, legend) {

    let newTmaTmeSelected = tmaTmeSelectedData;

    var index = legendItem.datasetIndex;

    const checkTmaTmeSelected = tmaTmeSelectedData.indexOf(index.toString());

    if (checkTmaTmeSelected > -1) {

      newTmaTmeSelected.splice(checkTmaTmeSelected, 1);

    } else {

      newTmaTmeSelected = [...newTmaTmeSelected, ...[index.toString()]];

    }

    tmaTmeSelectedData = newTmaTmeSelected;

    localStorage.setItem('tmaTmeSelectedData', JSON.stringify(tmaTmeSelectedData));

    defaultLegendClickHandler(e, legendItem, legend);

  };

  const optionsTmaTme = {
    plugins: {
      legend: {
        display: true,
        onClick: tmaTmeLegendClickHandler
      }
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };

  const addDays = function (date, daysToAdd) {
    var _24HoursInMilliseconds = 86400000;
    return new Date(date.getTime() + daysToAdd * _24HoursInMilliseconds);
  }

  const [open, setOpen] = React.useState(false);
  const titleHeader = 'voltar'
  const classes = useStyles();
  const [tmaTmeData, setTmaTmeData] = React.useState([]);
  const [pausasData, setPausasData] = React.useState([]);
  const [start, setStart] = React.useState(() => {
    const dt = new Date();
    return addDays(dt, -30); // padrão de dias atrás
  });
  const [end, setEnd] = React.useState(() => {
    const dt = new Date();
    dt.setDate(dt.getDate())
    dt.setHours(23)
    dt.setMinutes(59);
    return dt;
  });
  const [loading, setLoading] = React.useState(true);

  const dateToString = (date, time, format = false) => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    let timeString = '';
    if (time) {
      timeString = ' ' + hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
    }
    if (!format) {
      return yyyy + '-' + mm + '-' + dd + '' + timeString;
    }
    return dd + '/' + mm + '/' + yyyy + ' ' + timeString;
  }

  const loadData = async (start, end) => {
    setLoading(true)
    const tmatme = await api.get('v1/graficos/tmatme?start=' + dateToString(start, true) + '&end=' + dateToString(end, true))
    const pausas = await api.get('v1/graficos/pausas?start=' + dateToString(start, true) + '&end=' + dateToString(end, true));

    for (let tmatmeKey in tmatme.data.datasets) {
      const checkHidden = tmaTmeSelectedData.indexOf(tmatmeKey);
      if (checkHidden > -1) {
        tmatme.data.datasets[tmatmeKey].hidden = true;
      }
    }
    setTmaTmeData(tmatme.data);
    setPausasData(pausas.data);
    setLoading(false)
  }

  useEffect(() => {
    loadData(start, end)
    // setInterval(() => {
    //   loadData(start, end)
    // }, 50000)
  }, [])

  return (
    <>
      <main className={classes.content}>
        <Container maxWidth="lg" className={classes.container}>
          <div>
            {loading ? <Loading /> :
              (<>
                <Grid container spacing={3} style={{ paddingLeft: 20, paddingBottom: 20 }}>
                  <Grid item xs={2} style={{ alignSelf: 'center' }}>
                    <DatePicker
                      value={start}
                      onChange={setStart}
                      label={'Data'}
                    />
                  </Grid>
                  <Grid item xs={2} style={{ alignSelf: 'center', paddingTop: 20 }}>
                    <TimePickerCustom
                      value={start}
                      onChange={setStart}
                      label={'Hora'}
                    />
                  </Grid>
                  <Grid item xs={2} style={{ alignSelf: 'center' }}>
                    <DatePicker
                      value={end}
                      onChange={setEnd}
                      label={'Até a data'}
                    />
                  </Grid>
                  <Grid item xs={2} style={{ alignSelf: 'center', paddingTop: 20 }}>
                    <TimePickerCustom
                      value={end}
                      onChange={setEnd}
                      label={'Até a Hora'}
                    />
                  </Grid>
                  <Grid item xs={2} style={{ alignSelf: 'center', marginTop: 20 }}>
                    <Button
                      type="button"
                      variant="contained"
                      color="primary"
                      onClick={() => loadData(start, end)}
                    >
                      Gerar
                          </Button>
                  </Grid>
                </Grid>
                <div className='header' style={{ paddingTop: 20 }}>
                  <GridList cellHeight={500} className={classes.gridList} cols={3}>
                    <GridListTile key={1} cols={1}>
                      <Pie
                        data={pausasData}
                        options={options}
                      />
                    </GridListTile>
                    <GridListTile key={2} cols={2}>
                      <Line data={tmaTmeData} options={optionsTmaTme} />
                    </GridListTile>
                  </GridList>
                </div>
              </>)
            }
          </div>
        </Container>
      </main>
    </>
  )
}